import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

import { usePadStore } from '@stores/pad'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(async (to) => {
  const padStore = usePadStore()

  padStore.hydrateFromStorage(Discipline.Math)
  void padStore.ensureMath(to)
})
